import { useState, useEffect, useContext, JSX } from 'react';

import LiveReserveSituationLineBatchAttend from './attendBadge/LiveReserveSituationLineBatchAttend';
import LiveReserveSituationLineBatchNew from './newBadge/LiveReserveSituationLineBatchNew';


// シチュエーション各行で表示するバッチ
function LiveReserveSituationLineBatch(props: any) {

  const info = props.info;

  return (
    <>
    {info &&
      <>
        {/* new */}
        <LiveReserveSituationLineBatchNew
          info={info}
        />
        {/* 参加済み */}
        <LiveReserveSituationLineBatchAttend
          info={info}
        />
      </>
    }
    </>
  );
}
  
export default LiveReserveSituationLineBatch;